<div class="wnl-header">
  <p>
    WNL: Regular respiratory rate and quality. Lung sounds clear to auscultation. No cough noted.
    Pulse oximetry greater than 92% on room air. Symmetrical chest, no respiritory distress.
  </p>

  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()">
  <h2>Respiratory Pattern</h2>

  <assessment-row title="Rhythm">
    <emr-checkbox [control]="formGroup().controls.irregularRhythm" label="Irregular" />
  </assessment-row>
  <assessment-row title="Quality">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.quality" [options]="qualityOptions"
      [default]="qualityDefault" [(wnl)]="wnlManager.controlColl['quality'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" />
    @if (isOtherQuality) {
    <emr-input type="text" label="Comments" [control]="formGroup().controls.qualityOther" />
    }
  </assessment-row>

  <h2>Lung Sounds</h2>
  <div>
    <div class="lung-sound">
      <emr-input type="select" [hasWNL]="true" label="RUL" [control]="formGroup().controls.lungSoundsRul"
        [options]="lungSoundOptions" [default]="lungSoundDefault" [(wnl)]="wnlManager.controlColl['rul'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      @if (isOtherRUL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRulOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" [hasWNL]="true" label="RML" [control]="formGroup().controls.lungSoundsRml"
        [options]="lungSoundOptions" [default]="lungSoundDefault" [(wnl)]="wnlManager.controlColl['rml'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      @if (isOtherRML) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRmlOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" [hasWNL]="true" label="RLL" [control]="formGroup().controls.lungSoundsRll"
        [options]="lungSoundOptions" [default]="lungSoundDefault" [(wnl)]="wnlManager.controlColl['rll'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]=" true" />
      @if (isOtherRLL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsRllOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" [hasWNL]="true" label="LUL" [control]="formGroup().controls.lungSoundsLul"
        [options]="lungSoundOptions" [default]="lungSoundDefault" [(wnl)]="wnlManager.controlColl['lul'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      @if (isOtherLUL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsLulOther" />
      }
    </div>

    <div class="lung-sound">
      <emr-input type="select" [hasWNL]="true" label="LLL" [control]="formGroup().controls.lungSoundsLll"
        [options]="lungSoundOptions" [default]="lungSoundDefault" [(wnl)]="wnlManager.controlColl['lll'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      @if (isOtherLLL) {
      <emr-input type="text" label="Other" [control]="formGroup().controls.lungSoundsLllOther" />
      }
    </div>
  </div>

  <h2>Breathing</h2>
  <assessment-row title="Increased Work of Breathing">
    <emr-input type="text" [control]="formGroup().controls.increasedWorkOfBreathing" />
  </assessment-row>

  <h2>Cough</h2>
  <assessment-row title="Cough present?">
    <emr-checkbox [control]="formGroup().controls.cough" label="Yes" />
  </assessment-row>
  @if (isCoughPresent) {
  <assessment-row title="Describe cough">
    <emr-input type="select" label="Cough Description" [control]="formGroup().controls.coughDescription"
      [options]="coughDescriptionOptions" />
  </assessment-row>

  @if (isCoughProductive) {
  <assessment-row title="Describe productive cough">
    <emr-checkbox-group [control]="formGroup().controls.productiveDescription"
      [options]="productiveDescriptionOptions" />
  </assessment-row>
  }
  }

  <h2>Trach</h2>
  <assessment-row title="Trach Present">
    <emr-checkbox [control]="formGroup().controls.trachPresent" label="Yes"></emr-checkbox>
  </assessment-row>
  @if (isTrachPresent) {
  <assessment-row title="Inner Cannula Day Changed">
    <emr-input type="date" [control]="formGroup().controls.innerCannulaChangedDay" />
  </assessment-row>

  <assessment-row title="Trach Ties Changed">
    <emr-checkbox [control]="formGroup().controls.trachTiesChanged" label="Yes"></emr-checkbox>
  </assessment-row>

  <assessment-row title="Suction">
    <emr-input type="text" [control]="formGroup().controls.suction"></emr-input>
  </assessment-row>
  }
</div>